









































































































































































// import InventoryOrder from "@/views/InventoryOrder.vue";
import { InventoryOrderData } from "@/views/InventoryOrder.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import PrintTheadVue from "./PrintThead.vue";
import ReportMarginVue from "@/components/Print/ReportMargin.vue";
import { log } from "console";

@Component({
	components: {
		"t-head": PrintTheadVue,
		"report-margin": ReportMarginVue,
	},
})
export default class Print extends Vue {
	@Prop({ type: Array })
	list!: InventoryOrderData[];
	@Prop({ type: Number })
	way!: number;
	@Prop({ type: String })
	title!: string;

	printers: Electron.PrinterInfo[] = [];
	printer: Electron.PrinterInfo | null = null;
	printSize = "A4打印";
	size = ["A4打印", "凭证打印"];
	period = "";
	writerCopy = this.$store.state.accountBook.name;
	printWay = localStorage.getItem("printWay") ? +(localStorage.getItem("printWay")!) : 0;
	wayList = [{value: 0, key: "默认"}, { value: 1, key: "自定义打印" }];
	total = {
		number: 0,
		price: 0,
		money: 0
	}

	get listCopy() {
		const copy: InventoryOrderData[] = JSON.parse(
			JSON.stringify(this.list)
		);
		copy.forEach((e) => {
			e.remark = "";
			this.total.number += +e.number;
			this.total.price += +e.price;
			this.total.money += +e.money;
		});
		return copy;
	}
	// remark = "";
	getDefaultPrinter() {
		let printer = localStorage.getItem(
			this.printSize === "A4打印" ? "sheetPrinter" : "voucherPrinter"
		);

		if (printer != null) this.printer = JSON.parse(printer);
	}

	mounted() {
		this.getDefaultPrinter();
	}

	changePrintSize() {
		this.getDefaultPrinter();
	}

	startPrint() {
		if (this.$utils.notNull([this.printer])) {
			// 渲染打印页面至打印线程
			// const topArea = <HTMLElement>this.$el.querySelector(".top-area");
			const inner = (<HTMLElement>this.$el.querySelector(".top-area"))
				.innerHTML;
			this.$utils.sendToElectron(
				this.printSize === "A4打印" ? "print-sheet" : "print-voucher",
				inner,
				this.printer,
				undefined,
				undefined,
				undefined,
				+this.printWay
			);
		} else {
			this.$alert("请选择打印机");
		}
		this.$emit("close");
	}
}
